import * as qs from "qs";
import * as React from "react";
import { connect } from "react-redux";
import { Button } from "react-bootstrap";

import { AppShape, HurdleShape } from "@eave/shared/types/api";
import HurdleView from "underwriter_dashboard/shared/HurdleView";
import Select from "react-select";
import APIClient from "../../APIClient";
import WorksheetEditor from "../shared/WorksheetEditor";

const styles = require("underwriter_dashboard/hurdle_editors/styles.module.scss");

require(`../../../assets/stylesheets/components/underwriter_dashboard/hurdle_editors/\
disclosure_entities.scss`);

interface DisclosureEntitiesProps {
  app: AppShape;
  hurdle: HurdleShape;
  onHide: Function;
}

class DisclosureEntitiesEditor extends React.Component<DisclosureEntitiesProps, any> {
  constructor(props) {
    super(props);
    this.state = {
      stage: null,
      validStages: null,
      disclosureEntities: null,
    };
  }

  componentDidMount() {
    this.fetchValidDisclosureStages();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.stage !== this.state.stage) {
      this.fetchDisclosureEntities();
    }
  }

  fetchValidDisclosureStages = () => {
    APIClient.get(`/uw/valid_disclosure_stages`).then((response: any) => {
      const validStages = response.stages.map(stage => ({
        label: stage,
        value: stage,
      }));
      this.setState({ validStages });
    });
  };

  fetchDisclosureEntities = () => {
    const { stage } = this.state;
    if (!stage) {
      // stage is null if a disclosure stage is not currently selected
      return;
    }

    const { app } = this.props;
    const payload = { stage };
    APIClient.get(`/uw/${app.id}/generate_disclosure_entities?${qs.stringify(payload)}`).then(
      (response: any) => {
        this.setState({
          disclosureEntities: response,
        });
      },
    );
  };

  onSelectChange = e => {
    const { stage } = this.state;
    if (e && e.value === stage) return; // stage hasn't changed, do nothing

    this.setState({
      stage: e ? e.value : null,
      disclosureEntities: null,
    });
  };

  prettyPrint = discEnt => {
    let formatted = "";
    if (discEnt) {
      for (const key in discEnt) {
        if (!discEnt.hasOwnProperty(key)) continue;
        for (const subKey in discEnt[key]) {
          if (!discEnt[key].hasOwnProperty(subKey)) continue;
          const value = discEnt[key][subKey];
          formatted += `${subKey}\t${JSON.stringify(value)}\n`;
        }
      }
    }
    return formatted;
  };

  render() {
    const { app, hurdle, onHide } = this.props;
    const { validStages, stage, disclosureEntities } = this.state;

    return (
      <HurdleView app={app} hurdle={hurdle} onHide={onHide}>
        <p>View disclosure entities for stage:</p>
        <Select
          placeholder="Select a stage"
          clearable
          searchable
          value={stage}
          options={validStages}
          onChange={this.onSelectChange}
        />
        <pre>{this.prettyPrint(disclosureEntities)}</pre>
        <p>
          The following overrides the values reported in the last LE. Note: if a new LE is
          generated, any manual overrides will be lost, so make sure to apply necessary overrides
          right before generating a Closing Disclosure.
        </p>
        <WorksheetEditor
          appId={app.id}
          loanFileWsId={app.loan_file_worksheet_id}
          openToWsName="cash_to_close_items"
        />
      </HurdleView>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  app: ownProps.app,
  hurdle: ownProps.hurdle,
  onHide: ownProps.onHide,
});

export default connect(mapStateToProps)(DisclosureEntitiesEditor);
